import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Link,
  List,
  ListItem,
  Button,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import { motion } from "framer-motion";
import { Navigate, useNavigate } from "react-router-dom";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import BuildIcon from "@mui/icons-material/Build";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import Tooltip from "../../components/Tooltip/Tooltip";
import GuestSpeakers from "../../components/Speakers/Speakers";

const AboutSummerResidency2026 = () => {
  useEffect(() => {
    document.title = "About Summer Residency 2026 - MS Digital Hub";
  }, []);
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <Box
        sx={{
          width: "auto",

          padding: "0px 20px",
          margin: "0px auto",
          padding: { xs: "20px", sm: "30px", md: "1px 80px" },
          border: "none",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Summer Residency 2026
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Undergraduate students enrolled in any Mississippi two-or-four-year
          institution of higher learning are invited to apply to a residential
          six-week summer workshop offered by the Mississippi Digital Humanities
          Hub (the “Hub”) at Southern Miss in Hattiesburg, Mississippi. The
          residency will take place from Monday, June 15, 2026, through Friday,
          July 24, 2026. Participants will receive free housing and meals,
          reimbursement for travel, and a small stipend.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Digital Humanities is an evolving field that uses computers to explore
          scholarly questions in the humanities (English, history, philosophy
          and similar subjects). Digital Humanists use a wide range of tools,
          such as mapping, data visualization, text analysis, digital exhibits,
          and digital storytelling, to advance research, interpret cultural
          materials, and raise new questions about the past and present.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          The summer workshop emphasizes collaborative, hands-on engagement with
          these methods. Students with interests in literature, history,
          culture, and related fields will work together in a community of
          practice, experimenting with digital tools while developing their own
          research projects. Along the way, participants will experience the
          creative and exploratory dimensions of the digital humanities, where
          rigor and play meet to produce surprising insights.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Students selected for the summer workshop will:
        </Typography>
        <ul>
          <li>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "30px",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Develop research questions and apply research skills to interpret,
              analyze, and synthesize information{" "}
            </Typography>
          </li>
          <li>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "30px",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Create a public-facing digital project with clear goals,
              objectives, and audiences
            </Typography>
          </li>
          <li>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "30px",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Learn to use digital humanities tools and methods, and understand
              when and how to employ those tools and methods to support ethical
              research
            </Typography>
          </li>
          <li>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "30px",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Learn to communicate and market their newly acquired skills to
              prospective employers or graduate programs
            </Typography>
          </li>
        </ul>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          This six-week workshop is open to students currently enrolled in an
          undergraduate program in the state of Mississippi who will remain
          enrolled in Fall 2026 (current first-year students, sophomores, and
          juniors). Applications open January 22, 2026 and are due by 11:59 PM
          (CT) on March 31, 2026. Participation is limited to ten students.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          The Mississippi Digital Humanities Hub is a three-year grant-funded
          project to provide Mississippi scholars, archivists, and researchers
          with digitization and digital humanities skills needed to preserve the
          cultural and historical resources of Mississippi.
        </Typography>
      </Box>
    </motion.div>
  );
};

export default AboutSummerResidency2026;
